module.exports = __webpack_public_path__ + "img/signalizator-vice-fazi.a3272338.webp";